/* unplugin-vue-components disabled */import { render } from "./ScanSettings.vue?vue&type=template&id=3c4758a4&ts=true"
import script from "./ScanSettings.vue?vue&type=script&lang=ts"
export * from "./ScanSettings.vue?vue&type=script&lang=ts"

import "./ScanSettings.vue?vue&type=style&index=0&id=3c4758a4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__